import { render } from "./TriviaFinished.vue?vue&type=template&id=12b29289&scoped=true"
import script from "./TriviaFinished.vue?vue&type=script&lang=js"
export * from "./TriviaFinished.vue?vue&type=script&lang=js"

import "./TriviaFinished.vue?vue&type=style&index=0&id=12b29289&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b29289"]])

export default __exports__